{
  "info": "Info",
  "negative": "Fel",
  "positive": "Lyckades"
}
